module.exports = __webpack_public_path__ + "static/media/CreeksideGlenshomeowners-Handbookfinal.8c51bfdb.pdf";